import { render } from "./apps-list.vue?vue&type=template&id=00481f05&scoped=true"
import script from "./apps-list.vue?vue&type=script&lang=js"
export * from "./apps-list.vue?vue&type=script&lang=js"

import "./apps-list.vue?vue&type=style&index=0&id=00481f05&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00481f05"]])

export default __exports__